<template xmlns="http://www.w3.org/1999/html">
  <div style="height: 100vh;display: flex;flex-direction: column;justify-content:space-between;overflow:scroll;">
    <img src="/static/images/huaku/topbg.png" style="width: 100%;" />
    <img src="/static/images/huaku/logo.png" style="width: 78%;position: absolute;left: 11%;top:8%" />
    <img src="/static/images/huaku/pingzi.png" style="width: 15%;position: absolute;right: 13%;bottom:2%" />

    <div style="position: absolute;display: flex;flex-direction: column;
      justify-content: center;align-items: center;width: 100%;background-color: rgb(46,96,62);padding-top:15px;padding-bottom: 15px;
      top:30%">
      <div style="color: white;font-size: 16px;">关注官方公众号查防伪</div>
      <div style="display: flex;justify-content: center;align-items: center;margin-top: 7px;">
        <img src="/static/images/huaku/left.png" style="width: 10%;margin-right: 10px;" />
        <img src="/static/images/huaku/wechat.png" style="width: 23%;" />
        <img src="/static/images/huaku/right.png" style="width: 10%;margin-left: 10px;" />
      </div>
      <div class="steps-section">
          <div class="step-item">
            <div class="step-header">
              <div class="step-tag">第一步</div>
            </div>
            <div class="step-content">
              长按识别二维码-关注【健养堂健康指南】公众号
            </div>
          </div>
          <div class="step-item">
            <div class="step-header">
              <div class="step-tag">第二步</div>
            </div>
            <div class="step-content">
              点击"防伪查询"或点击菜单栏>防伪查询
            </div>
          </div>
          <div class="step-item">
            <div class="step-header">
              <div class="step-tag">第三步</div>
            </div>
            <div class="step-content">
              选择扫码或输码，查询商品真伪
            </div>
          </div>
        </div>

    </div>


    <!-- style="position: fixed;bottom: 0;" -->
    <img src="/static/images/huaku/bottombg.png" style="width: 100%;">
  </div>
</template>
<style scoped>

.steps-section {
  background: white;
  border-radius: 10px;
  padding: 15px;
  text-align: left;
  width:87%;
  margin-top: 10px;
}

.step-item {
  margin-bottom: 15px;
}

.step-item:last-child {
  margin-bottom: 0;
}

.step-header {
  margin-bottom: 8px;
}

.step-tag {
  display: inline-block;
  background-color: #2E603E;  /* 深绿色背景 */
  color: white;
  font-size: 14px;
  padding: 6px 15px;
  border-radius: 20px;
  line-height: 1.2;
}

.step-content {
  color: #333333;
  font-size: 12px;
  line-height: 1.1;
  padding-left: 5px;
  margin-top: 5px;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      isShow: false,
      antiCode: "",
      firstQueryTime: "",
      antiTrue: false,
      antiFalse: false
    }
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      const code = params.c;
      getAntiResult(code).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          this.antiFalse = false
          this.antiTrue = false
          alert("防伪查询失败,请联系管理员");
        } else if (data.code == "300106") {
          this.antiFalse = false
          this.antiTrue = false
          alert(data.message);
        } else {
          this.antiCode = this.insertSpace(data.data.code)
          this.firstQueryTime = data.data.firstQueryTime
          if (data.code === "300102") {
            this.antiFalse = true
            this.antiTrue = false
          } else if (data.code == "300101") {
            this.antiFalse = false
            this.antiTrue = true
          }
        }
        this.isShow = false
      }).catch(err => {
        this.isShow = false
        alert("查询异常，请联系管理员")
      }
      )

    },

    insertSpace(code) {
      return code.replace(/\d{4}/g, function (match) {
        return match + ' ';
      });
    }
  },
  created: function () {
    //this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HuaKu/Index.vue